import './assets/styles/main.css';
import './assets/styles/tailwind.css';
import { createApp } from 'vue';
import i18n from './i18n';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { createGtag } from 'vue-gtag';
import { createHead } from '@unhead/vue';

const app = createApp(App);
const head = createHead();

app
  .use(store)
  .use(router)
  .use(i18n)
  .use(head)
  .use(createGtag({
    tagId: 'G-VDRTVZQC2B',
    pageTracker: { router },
  }))
  .mount('#app');
